<div class="wrapper">
  <a [class.active]="active"
     [routerLink]="item.href"
     class="inter large">
    {{ item.label | i18n }}
  </a>
</div>
